const config = {
    thisVersion: "2.0",
}

export default config;
